<section
  *ngIf="mantenimiento"
  class="maintenance-notice"
  [class.is-login]="modo === 'login'"
  [class.is-system]="modo === 'sistema'"
  role="status"
>
  <div class="notice-icon" aria-hidden="true">
    <i class="material-icons">schedule</i>
  </div>
  <div class="notice-content">
    <div class="notice-heading">
      <strong>{{ mantenimientoEnCurso ? 'Mantenimiento en curso' : 'Mantenimiento programado' }}</strong>
      <span *ngIf="!mantenimientoEnCurso">Hoy, {{ formatearHora(mantenimiento.fechaInicio) }}–{{ formatearHora(mantenimiento.fechaFin) }}</span>
      <span *ngIf="mantenimientoEnCurso">Fin estimado: {{ formatearHora(mantenimiento.fechaFin) }}</span>
    </div>
    <p>{{ mantenimiento.mensaje }}</p>
  </div>
  <button
    type="button"
    class="notice-close"
    (click)="cerrar()"
    aria-label="Cerrar aviso de mantenimiento"
  >
    <i class="material-icons">close</i>
  </button>
</section>
